import { useEffect, useState } from 'react';
import useAuth from 'hooks/UseAuth';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import isAfter from 'date-fns/isAfter';

import { Header } from 'shared/components/organisms/Header/Header';
import { Sidebar } from 'shared/components/organisms/Sidebar/Sidebar';
import { RevenueTag } from 'shared/components/molecules/RevenueTag/RevenueTag';
import { SendDocuments } from 'shared/components/molecules/SendDocumentsModal/SendDocumentsModal';
import { DocumentsPainel } from 'shared/components/molecules/DocumentsPainel/DocumentsPainel';
import { ApprovedDocumentsModal } from 'shared/components/molecules/ApprovedDocumentsModal/ApprovedDocumentsModal';
import { DocumentsMissingModal } from 'shared/components/molecules/DocumentsMissingModal/DocumentsMissingModal';

import { parseDate } from 'utils/parseDate';
import api from 'services/api';

import {
  Container,
  Content,
  AttendanceCard,
  Banner,
  BannerWrapper,
  Profile,
  ProfileSection,
  Toggle,
  Wellcome,
  WellcomeRow,
} from './_home';
import { IAppointments } from 'pages/Agenda/interfaces';
import { NextAppointmentPanel } from 'shared/components/molecules/NextAppointmentPanel/NextAppointmentPanel';
import { MobileLinks } from 'shared/components/molecules/MobileLinks/MobileLinks';

export const Home = () => {
  const { user, setUser } = useAuth()
  const updatedDate = new Date (user?.provider?.is_working_updated_at)
  const history = useHistory()

  const [toggleActive, setToggleActive] = useState<boolean>(!!user?.provider?.is_working);
  const [lastUpdate, setLastUpdate] = useState(parseDate(`${updatedDate}`));

  const [showModal, setShowModal] = useState<boolean>(false);
  const [showMissingDocumentModal, setShowMissingDocumentsModal] = useState<boolean>(false);
  const [showApprovedDocumentModal, setShowApprovedDocumentModal] = useState<boolean>(false);

  const [nextAppointment, setNextAppointment] = useState<IAppointments>();

  const userServiceName = user?.provider?.service_types[0]?.name || '---'

  const handleAddDocumentation = () => {
    setShowModal(true);
  }

  const handleShowCalls = () => {
    if(user?.documents_status !== 2){
      setShowMissingDocumentsModal(true)
    } else {
      handleToggleStore()
    }
  }

  const handleToggleStore = async () => {
    try {
      const response: any = await api.put('/providers', {is_working: !toggleActive})
      const responseProvider = response?.data?.provider

      setUser(prevState => ({
        ...prevState,
        provider: {
          ...responseProvider
        }
      }))

      setLastUpdate(parseDate(`${responseProvider?.is_working_updated_at}`))
      setToggleActive(prevState => !prevState)
     } catch (error: any) {
       toast.error(error?.response?.data?.message || 'Oops, não foi possível aplicar a alteração, tente novamente mais tarde!')
     }
  }

  const handleApprovedDocuments = () => {
    if(user?.documents_status === 2){
      const documentsApproved = localStorage.getItem('@RepfyProvider: DocumentsApproved')

      if (!documentsApproved) {
        setShowApprovedDocumentModal(true)
      }
    }
  }

  const getNextAppointment = async () => {
    try {

      const response = await api.get<{
        service_appointments: IAppointments[],
      }>('/appointments', {
        params: {
          canceled: false,
          done: false,
          initial_date: '1970-01-01',
          final_date: '2050-01-01',
        }
      });

      const { service_appointments } = response.data;

      /* const futureAppointments = service_appointments.filter((appointment) => isAfter(new Date(appointment.date), new Date()));

      const sortedAppointmentsByDate = futureAppointments.sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });

      const nextAppointment = sortedAppointmentsByDate[0] || undefined; */

      const nextAppointment = service_appointments[0] || undefined;

      setNextAppointment(nextAppointment);

    } catch (error: any) {
      toast.error('Erro ao obter os agendamentos, por favor tente novamente mais tarde');
    }
  }

  useEffect(() => {
    handleApprovedDocuments()
  }, []);

  useEffect(() => {
    getNextAppointment()
  }, []);

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <WellcomeRow>
          <Wellcome>
            <span className="wellcome__message">
              Seja bem vindo
              <strong className="wellcome__message__strong"> {user?.individual_person?.name || 'Prestador'}!</strong>
            </span>

            <p className="wellcome__message__description">
              Atenda à solicitações dos clientes e acompanhe seu faturamento em
              tempo real!
            </p>
          </Wellcome>

          <MobileLinks />

          <RevenueTag />
        </WellcomeRow>
      </Content>

      <ProfileSection>
        <Content>
          <div className="profile-section__first-row">
            <div className="profile__wrapper">
              <Profile>
                <span className="profile__title-wrapper">
                  <h3 className="profile__title">
                    Seu perfil profissional:
                  </h3>
                  <h1 className="profile__title-service-name">
                    {userServiceName}
                  </h1>
                </span>
              </Profile>

              {
                nextAppointment ? (
                  <NextAppointmentPanel appointment={nextAppointment} />
                ) : (
                  <DocumentsPainel
                    onClick={handleAddDocumentation}
                  />
                )
              }
            </div>

            <AttendanceCard>
              <span className="attendance-card__title">
                Meus atendimentos - {toggleActive ? 'Aberto':'Fechado'}
              </span>
              <p className="attendance-card__text">
              {toggleActive
                ? 'Nesta modalidade, você está disponível para receber chamados no app prestador'
                : 'Nesta modalidade, as solicitações de chamado não aparecerão para você'
              }
              </p>
              <Toggle>
                <div
                  className={`toggle__wrapper ${toggleActive ? 'active' : ''}`}
                  onClick={handleShowCalls}
                >
                  <div
                    className={`toggle__wrapper__pin
                  ${toggleActive ? 'pin-active' : ''}`}
                  ></div>
                </div>
              </Toggle>
              <span className="attendance-card__closing-indicator">
                Loja {toggleActive ? 'Aberta':'Fechada'} desde: <strong>{lastUpdate}</strong>
              </span>
            </AttendanceCard>
          </div>

          <BannerWrapper>
            <Banner>
              <span>
                Profissionais de qualidade <strong> é na Repfy</strong>
              </span>
            </Banner>
            <div className="hex"></div>
          </BannerWrapper>

          {showModal && (
            <SendDocuments
              toggleModal={setShowModal}
              callback={() => history.push('/enviar-documentos')}
            />
          )}

          {showMissingDocumentModal && (
            <DocumentsMissingModal
              toggleModal={setShowMissingDocumentsModal}
            />
          )}

          {showApprovedDocumentModal && (
            <ApprovedDocumentsModal
              toggleModal={setShowApprovedDocumentModal}
            />
          )}
        </Content>
      </ProfileSection>
    </Container>
  );
};
